import { firebase } from '../config/configureFirebase';
import { onValue, set, get } from 'firebase/database';

export const FETCH_WEEKLY_RECOGNITION = 'FETCH_WEEKLY_RECOGNITION';
export const FETCH_WEEKLY_RECOGNITION_SUCCESS = 'FETCH_WEEKLY_RECOGNITION_SUCCESS';
export const FETCH_WEEKLY_RECOGNITION_FAILED = 'FETCH_WEEKLY_RECOGNITION_FAILED';
export const SAVE_WEEKLY_RECOGNITION = 'SAVE_WEEKLY_RECOGNITION';
export const SAVE_WEEKLY_RECOGNITION_SUCCESS = 'SAVE_WEEKLY_RECOGNITION_SUCCESS';
export const SAVE_WEEKLY_RECOGNITION_FAILED = 'SAVE_WEEKLY_RECOGNITION_FAILED';

export const fetchWeeklyRecognition = () => (dispatch) => {
    const { weeklyRecognitionRef } = firebase;
    dispatch({ type: FETCH_WEEKLY_RECOGNITION, payload: null });
    onValue(weeklyRecognitionRef, snapshot => {
        if (snapshot.val()) {
            const data = snapshot.val();
            const entries = Object.keys(data).map(k => ({ id: k, ...data[k] }));
            dispatch({ type: FETCH_WEEKLY_RECOGNITION_SUCCESS, payload: entries });
        } else {
            dispatch({ type: FETCH_WEEKLY_RECOGNITION_SUCCESS, payload: [] });
        }
    }, error => {
        dispatch({ type: FETCH_WEEKLY_RECOGNITION_FAILED, payload: error.message });
    });
};

export const saveWeeklyRecognition = (weekId, data) => async (dispatch) => {
    const { weeklyRecognitionEditRef } = firebase;
    dispatch({ type: SAVE_WEEKLY_RECOGNITION, payload: null });
    try {
        await set(weeklyRecognitionEditRef(weekId), data);
        dispatch({ type: SAVE_WEEKLY_RECOGNITION_SUCCESS, payload: null });
    } catch (error) {
        dispatch({ type: SAVE_WEEKLY_RECOGNITION_FAILED, payload: error.message });
    }
};

export const fetchPublishedWeeklyRecognition = () => (dispatch) => {
    const { weeklyRecognitionRef } = firebase;
    dispatch({ type: FETCH_WEEKLY_RECOGNITION, payload: null });
    onValue(weeklyRecognitionRef, snapshot => {
        if (snapshot.val()) {
            const data = snapshot.val();
            const published = Object.keys(data)
                .map(k => ({ id: k, ...data[k] }))
                .filter(e => e.status === 'published')
                .sort((a, b) => (b.publishedAt || 0) - (a.publishedAt || 0));
            dispatch({ type: FETCH_WEEKLY_RECOGNITION_SUCCESS, payload: published });
        } else {
            dispatch({ type: FETCH_WEEKLY_RECOGNITION_SUCCESS, payload: [] });
        }
    }, error => {
        dispatch({ type: FETCH_WEEKLY_RECOGNITION_FAILED, payload: error.message });
    });
};
